import React from 'react';
import { CreditCardIcon, DownloadIcon, ShieldCheckIcon, LockIcon } from 'lucide-react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
const trustItems = [{
  icon: LockIcon,
  label: 'Pagamento sicuro'
}, {
  icon: DownloadIcon,
  label: 'Accesso immediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garanzia 7 giorni'
}, {
  icon: CreditCardIcon,
  label: 'Nessun abbonamento'
}];
export function Offer() {
  return <section id="offerta" className="w-full bg-white px-5 py-14 sm:py-24" data-id="element-151" data-mp="u0xthpsq9wzt">
      <div className="mx-auto max-w-md" data-id="element-152" data-mp="p11wwbmd17ua">
        <div className="text-center" data-id="element-153" data-mp="13x14zm9gz7zf">
          <span className="eyebrow-rule text-[10px] font-bold uppercase tracking-[0.2em] text-teal sm:text-[11px]" data-id="element-154" data-mp="13y2gtsyb7yi7">
            Pagamento unico
          </span>
          <h2 className="mt-3 font-display text-[1.6rem] font-black leading-tight tracking-tight text-navy sm:text-[2.2rem]" data-id="element-155" data-mp="2fc68gshfdak3">
            Offerta di Lancio{' '}
            <span className="italic text-grape" data-id="element-156" data-mp="2acl8qfufky6b">Imbattibile</span>
          </h2>
        </div>

        <div className="relative mt-9 rounded-3xl border-2 border-tangerine bg-white px-6 pb-6 pt-9 shadow-soft sm:px-7 sm:pb-7" data-id="element-157" data-mp="pjp9xxd4gsoc">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-tangerine px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-158" data-mp="ul4y3yaljfay">
            Pack Arte Pronta · -93%
          </span>

          <img src="https://cdn.magicpatterns.com/uploads/o6EQirRZHassHc8uGWL9hp/0939a34e-f34e-4a6d-b780-4e1de598f781.webp" alt="Tutto il pack Arte Pronta: 8 volumi, versione digitale e i 5 bonus" className="mx-auto mb-4 h-32 w-full object-contain sm:h-44" data-id="element-159" data-mp="6usgfvpju476" />

          <dl className="text-[13px] sm:text-sm" data-id="element-160" data-mp="kl485ti820xs">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-navy/10 py-2.5" data-id="element-161" data-mp="kmfdvyv89irj">
                <dt className="text-navy/75" data-id="element-162" data-mp="3k6t1q00jil4l">{row.label}</dt>
                <dd className="font-bold text-navy" data-id="element-163" data-mp="3o8o4l8y4d6kh">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between gap-4 border-b border-navy/10 py-2.5" data-id="element-164" data-mp="vepbv4sad9wr">
              <dt className="font-bold uppercase tracking-wide text-navy" data-id="element-165" data-mp="qfurvzil1fb2">
                Valore totale
              </dt>
              <dd className="font-bold text-navy/40 line-through" data-id="element-166" data-mp="154qv9j9p245c">€273</dd>
            </div>
          </dl>

          <p className="mt-4 text-center text-[10px] font-extrabold uppercase tracking-[0.18em] text-teal" data-id="element-167" data-mp="108k08liu6d26">
            Oggi a soli
          </p>
          <p className="flex items-end justify-center gap-2 pb-4 pt-1" data-id="element-168" data-mp="7il7af1itvs8">
            <span className="font-display text-6xl font-black leading-none text-tangerine" data-id="element-169" data-mp="lhkxhr4omiqi">
              €19
            </span>
            <span className="pb-1.5 font-display text-lg font-bold text-navy/35 line-through" data-id="element-170" data-mp="hfpumi73rxam">
              €273
            </span>
          </p>

          <CtaButton label="Scarica Arte Pronta ora" className="w-full" data-id="element-171" data-mp="1wyt14a7i7utm" />

          <ul className="mt-5 grid grid-cols-2 gap-x-3 gap-y-2.5 border-t border-navy/10 pt-5" data-id="element-172" data-mp="1sucycht6t3im">
            {trustItems.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2 text-[11px] font-semibold text-navy/65" data-id="element-173" data-mp="25e0dtnjqi232">
                <Icon className="h-3.5 w-3.5 shrink-0 text-teal" aria-hidden="true" data-id="element-174" data-mp="1qhj5l56ud3kq" />
                {label}
              </li>)}
          </ul>

          <p className="mt-4 text-center text-[11px] leading-relaxed text-navy/50" data-id="element-175" data-mp="1vhnd45prunyt">
            Pagamento unico · Accesso illimitato · Soddisfatta o rimborsata
          </p>
        </div>
      </div>
    </section>;
}